<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Vendas Checklist</h1>
    <div class="mb-6 flex justify-between items-end">
      <text-input v-model="form.search" class="w-full max-w-md mr-4" label="Cliente" />
      <select-2-input v-model="form.cidade" :filterable="false" :options="cidades" :get-option-label="option =>`${option.cidade} - ${option.uf}` " label="Cidade" class="w-full max-w-md mr-4" @search="onSearch">
        <template slot="no-options">
          Pesquise uma cidade
        </template>
      </select-2-input>
    </div>
    <div class="mb-6 flex justify-between items-end">
      <select-2-input v-model="form.status" :reduce="row => row.value" :options="statusOptions" label="Situação" class="w-full max-w-md mr-4" />
      <select-2-input v-model="form.atencao" :reduce="row => row.value" :options="atencaoOptions" label="Atenção" class="w-full max-w-md mr-4" />
    </div>
    <div class="mb-6 flex justify-between items-end">
      <select-2-input v-model="form.responsavel" :reduce="row => row.idPessoa" :get-option-label="option => option.razaoSocial" :options="responsaveis" label="Responsável" class="w-full max-w-md mr-4" />
      <text-input v-model="form.venda" label="Nº Pedido" class="w-full max-w-md mr-4" />
    </div>
    <div class="mb-6 flex justify-between items-end">
      <inertia-link class="btn-indigo" :href="route('vendas.create')">
        <span>Criar</span>
        <span class="hidden md:inline">CheckList</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">ID</th>
          <th class="px-6 pt-6 pb-4">Cliente</th>
          <th class="px-6 pt-6 pb-4">Situação</th>
          <th class="px-6 pt-6 pb-4">Cidade</th>
          <th class="px-6 pt-6 pb-4">Atenção</th>
        </tr>
        <tr v-for="check in checklist.data" :key="check.idCheck" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t inline-flex">
            <a class="px-2 flex items-center" :href="route('vendas.print', check.idCheck)" tabindex="-1" target="_blank">
              <icon name="printer" class="block w-6 h-6 fill-gray-400" />
            </a>
            <inertia-link class="px-1 py-4 flex items-center focus:text-indigo-500" :href="route('vendas.edit', check.idCheck)">
              {{ check.idCheck }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('vendas.edit', check.idCheck)">
              {{ check.cliente }}
            </inertia-link>
          </td>
          <td class="border-t">
            {{ status(check.status) }}
          </td>
          <td class="border-t">
            {{ check.cidade }}
          </td>
          <td class="border-t">
            {{ atencao(check.especificacoes) }}
          </td>
          <td class="border-t w-px ">
            <inertia-link class="px-4 flex items-center" :href="route('vendas.edit', check.idCheck)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="checklist.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nenhum Checklist Encontrado.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="checklist.links" :query="filters" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import debounce from 'lodash/debounce'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import TextInput from '../../Shared/TextInput.vue'
import Select2Input from '../../Shared/Select2Input.vue'
export default {
  metaInfo: { title: 'Vendas' },
  components: {
    Icon,
    Pagination,
    TextInput,
    Select2Input,
  },
  layout: Layout,
  props: {
    filters: Object,
    checklist: Object,
    cidades: Array,
    responsaveis: Array,
  },
  data() {
    return {
      options: [],
      atencaoOptions: [
        {
          label: 'TODOS',
          value: 'T',
        },
        {
          label: 'DESENVOLVIMENTO',
          value: 'D',
        },
        {
          label: 'COMERCIAL',
          value: 'C',
        },
        {
          label: 'IMPLANTAÇÃO',
          value: 'I',
        },
      ],
      statusOptions: [
        {
          label: 'TODAS',
          value: 'T',
        },
        {
          label: 'AGUARDANDO',
          value: 'A',
        },
        {
          label: 'APROVADO',
          value: 'AP',
        },
        {
          label: 'REJEITADO',
          value: 'R',
        },
        {
          label: 'FINALIZADO',
          value: 'F',
        },
      ],
      selectedCidade:'',
      form: {
        search: this.filters.search,
        cidade: this.filters.cidade,
        status: this.filters.status,
        atencao: this.filters.atencao,
        responsavel: this.filters.responsavel,
        searchCidade: this.filters.searchCidade,
        venda: this.filters.venda,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: debounce(function() {
        this.$inertia.get(this.route('vendas'), pickBy(this.form), { preserveState: true })
      }, 500),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    onSearch(search) {
      if(search.length) {
        this.form.searchCidade=search
      }
    },
    onSelectedCidade(cidade) {
      this.form.cidade=cidade
    },
    atencao(especificacoes){
      const retorno = []
      const desenvolvimento = especificacoes.some(row => row.especificacao?.desenvolvimento ==  'S')
      const comercial = especificacoes.some(row => row.especificacao?.comercial ==  'S')
      const implantacao = especificacoes.some(row => row.especificacao?.implantacao ==  'S')
      if(desenvolvimento){
        retorno.push('Desenvolvimento')
      }
      if(comercial){
        retorno.push('Comercial')
      }
      if(implantacao){
        retorno.push('Implantação')
      }
      return retorno.join(',')
    },
    status(status){
      switch (status) {
      case 'A':
        return 'AGUARDANDO'
      case 'AP':
        return 'APROVADO'
      case 'R':
        return 'REJEITADO'
      case 'F':
        return 'FINALIZADO'
      default:
        return 'AGUARDANDO'
      }
    },
  },


}
</script>
